import { render, staticRenderFns } from "./TablePartner.vue?vue&type=template&id=587da198&"
import script from "./TablePartner.vue?vue&type=script&lang=js&"
export * from "./TablePartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports